import { HttpContextToken } from '@angular/common/http';

// Keep the HTTP status for requests that need to distinguish missing data from failures.
export const HTTP_ERROR_RESPONSE = new HttpContextToken<boolean>(() => false);
